import { render, staticRenderFns } from "./LexonSimpleGridComponent.vue?vue&type=template&id=68ec4db6&scoped=true"
import script from "./LexonSimpleGridComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LexonSimpleGridComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LexonSimpleGridComponent.vue?vue&type=style&index=0&id=68ec4db6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec4db6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ec4db6')) {
      api.createRecord('68ec4db6', component.options)
    } else {
      api.reload('68ec4db6', component.options)
    }
    module.hot.accept("./LexonSimpleGridComponent.vue?vue&type=template&id=68ec4db6&scoped=true", function () {
      api.rerender('68ec4db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonSimpleGrid/LexonSimpleGridComponent.vue"
export default component.exports